// extracted by mini-css-extract-plugin
module.exports = {"container":"Ad_container__ARhOT","square":"Ad_square__WO1LN","landscape":"Ad_landscape___BYhw","responsive":"Ad_responsive__RvP8S","cover":"Ad_cover__iINC8"};